module.exports = __webpack_public_path__ + "img/blue-logo.3c54f91f.png";